import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import AppBar from "@material-ui/core/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import Grid from "@material-ui/core/Grid";
import {Snackbar} from "@material-ui/core";
import MuiAlert from "@mui/material/Alert";
import {BASE_URL, BASE_URL_MESSENGER, BASE_URL_MESSENGER_API, URL_GROUP_AVATAR} from "../../Const";
import {styled} from "@mui/material/styles";
import MuiBottomNavigationAction from "@mui/material/BottomNavigationAction";
import BottomNavigation from "@mui/material/BottomNavigation";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import GroupWorkOutlinedIcon from '@mui/icons-material/GroupWorkOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import GroupIcon from "../../assets/icons/group.svg";
import Divider from "@material-ui/core/Divider";
import IconButton from "@mui/material/IconButton";
import {Link} from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import {GroupRepository} from "../../Repository/GroupRepository";
import Typography from "@material-ui/core/Typography";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";


const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export class ContactListComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            channelList: [],
            openSnackbar: false,
            message: "",
            snackbarType: "success",
        }
    }

    componentDidMount() {
        this.fetchChannelList()
    }

    MessengerMenu = () => {
        const [value, setValue] = React.useState("messenger/channels");
        // const navigate = useNavigate()
        const BottomNavigationAction = styled(MuiBottomNavigationAction)(`
  color: rgba(0,0,0,1);
  &.Mui-selected {
    color: black;
  }
`);
        return (
            <BottomNavigation
                style={{
                    width: '100%',
                    background: 'rgba(232,232,232,0.3)',
                    position: 'fixed',
                    fontFamily: "IRANSans",
                    top: 70,
                }}
                showLabels
                value={value}
                onChange={(event, newValue) => {
                    window.location.assign(BASE_URL_MESSENGER + newValue);

                    setValue(newValue);
                }}>
                <BottomNavigationAction label={<Typography style={{fontSize: 12,}}>مخاطبین</Typography>}
                                        value="contacts" icon={<GroupsOutlinedIcon/>}/>
                <BottomNavigationAction label={<Typography style={{fontSize: 12,}}>گروه‌ها</Typography>} value="groups"
                                        icon={<GroupWorkOutlinedIcon/>}/>
                <BottomNavigationAction label={<Typography style={{fontSize: 12,}}>کانال</Typography>} value="channels"
                                        icon={<CampaignOutlinedIcon/>}/>
                <BottomNavigationAction label={<Typography style={{fontSize: 12,}}>پیام‌ها</Typography>} value=""
                                        icon={<QuestionAnswerOutlinedIcon/>}/>

            </BottomNavigation>

        )
    }

    FormPropsTextFields = () => {
        const [value, setValue] = React.useState("messenger");
        // const navigate = useNavigate()
        const BottomNavigationAction = styled(MuiBottomNavigationAction)(`
  color: rgba(0,0,0,1);
  &.Mui-selected {
    color: black;
  }
`);

        return (<BottomNavigation

                style={{
                    width: '100%',
                    background: 'rgba(232,232,232,0.3)',
                    position: 'fixed',
                    fontFamily: "IRANSans",
                    margin: 0,
                    padding: 0,
                    bottom: 0,
                }}
                showLabels
                value={value}
                onChange={(event, newValue) => {
                    window.location.assign(BASE_URL + newValue);

                    setValue(newValue);
                }}>

                <BottomNavigationAction label={<Typography style={{fontSize: 12,}}>پیام رسان</Typography>}
                                        value="messenger/dialogs" icon={<SmsOutlinedIcon/>}/>
                <BottomNavigationAction label={<Typography style={{fontSize: 12,}}>پروفایل</Typography>} value="profile"
                                        icon={<AccountCircleIcon/>}/>
                <BottomNavigationAction label={<Typography style={{fontSize: 12,}}>محصولات</Typography>} value="offers"
                                        icon={<DnsOutlinedIcon/>}/>
                <BottomNavigationAction label={<Typography style={{fontSize: 12,}}>فروشگاه‌ها</Typography>} value=""
                                        icon={<StorefrontOutlinedIcon/>}/> </BottomNavigation>
        )
    }

    fetchChannelList = () => {
        fetch(BASE_URL_MESSENGER_API + 'groups?mode=channel', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_messenger_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                    if (results.code === "200") {
                        GroupRepository.saveGroups(results.data)

                        this.setState({channelList: results.data})
                    }

                },
                (error) => {
                    console.log("error")
                }
            );
    }


    render() {

        if (localStorage.getItem("pwa_messenger_token") === null) {
            window.location.assign(BASE_URL + 'messenger/verify');
        }

        const handleCloseSnackbar = (e) => {
            this.setState({openSnackbar: false})
        }

        return (
            <React.Fragment>

                <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                    <ToolbarMui>


                        <ListItemText align="center"><strong style={{
                            fontSize: 18,
                            overflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            color: 'black'
                        }}>پیام‌رسان</strong></ListItemText>

                        <IconButton component={Link} to={"/search"} style={{color: 'black'}}><SearchIcon/></IconButton>

                    </ToolbarMui>

                    <this.MessengerMenu/>

                </AppBar>


                <List style={{marginTop: 110}}> {this.state.channelList.map((item) => (

                    <ListItem key={item.id} component={Link}
                              to={"/messenger/channel?chat_id=" + item.chat_id}>

                        <Grid container>
                            <Grid xs={2}>
                                <img style={{
                                    borderRadius: '50%',
                                    width: 46,
                                    height: 46
                                }}
                                     alt="avatar2"
                                     src={item.avatar != null ? URL_GROUP_AVATAR + item.avatar : GroupIcon}/>

                            </Grid>

                            <Grid item xs={5}>
                                <ListItemText style={{align: 'right'}}>

                                    <p style={{
                                        marginRight: 12,
                                        overflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        color: '#313131',
                                        fontWeight: 'bold',
                                        fontSize: 14,
                                    }}
                                       align='right'>
                                        {item.title == null ? ("نامشخص") :
                                            item.title
                                        }

                                    </p>
                                </ListItemText>

                            </Grid>
                            <Grid item xs={5}>
                                <ListItemText style={{align: 'right'}}>

                                    <p style={{
                                        overflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        color: '#CFD8DC',
                                        fontSize: 14,
                                    }}
                                       align='right'>{item.member_count + " عضو"}
                                    </p>
                                </ListItemText>

                            </Grid>

                            <Grid item xs={2}/>
                            <Grid item xs={10}>
                                <ListItemText style={{align: 'right'}}>

                                    <p style={{
                                        fontSize: 14,
                                        padding: 0,
                                        margin: 0,
                                        color: '#CFD8DC',
                                    }} align='right'>{item.description}</p>
                                </ListItemText>

                            </Grid>

                            <Grid item xs={12}>

                                <Divider light style={{margin: 0}}/>
                            </Grid>

                        </Grid>


                    </ListItem>

                ))
                }
                </List>

                <Snackbar open={this.state.openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <Alert onClose={handleCloseSnackbar} severity={this.state.snackbarType} sx={{width: '100%'}}>
                        {this.state.message}
                    </Alert>
                </Snackbar>

                <this.FormPropsTextFields/>

            </React.Fragment>


        );

    }

}
